import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  tone?: 'light' | 'dark';
  align?: 'center' | 'left';
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  tone = 'light',
  align = 'center'
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  const alignment = align === 'center' ? 'text-center items-center' : 'text-left items-start';
  return <div className={`flex flex-col ${alignment}`} data-id="element-276" data-mp="blolhjj1gwaf">
      {eyebrow && <span className={`mb-3 inline-block rounded-full px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.18em] ${isDark ? 'bg-gold-500/15 text-gold-300' : 'bg-navy-900 text-gold-300'}`} data-id="element-277" data-mp="gjq09s9fm9g3">
          {eyebrow}
        </span>}
      <h2 className={`text-balance text-[26px] font-black uppercase leading-[1.1] tracking-tight sm:text-4xl lg:text-[42px] ${isDark ? 'text-white' : 'text-navy-900'}`} data-id="element-278" data-mp="ujhkwbugeo32">
        {title}
      </h2>
      {subtitle && <p className={`mt-4 max-w-2xl text-[15px] leading-relaxed sm:text-lg ${isDark ? 'text-white/70' : 'text-navy-900/70'}`} data-id="element-279" data-mp="1ta8qhle1krqt">
          {subtitle}
        </p>}
    </div>;
}